export default "__VITE_ASSET__rdgJY2IK__"